var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCalloutError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E9594C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.62 24.657c-.24.216-.564.337-.902.337-.338 0-.662-.121-.901-.337L20 21.747l-2.816 2.909a1.292 1.292 0 0 1-.413.254 1.394 1.394 0 0 1-.98.003 1.294 1.294 0 0 1-.417-.25 1.152 1.152 0 0 1-.277-.377 1.056 1.056 0 0 1 .004-.886c.065-.14.16-.267.28-.374l2.93-3.025-2.93-3.027a1.156 1.156 0 0 1-.281-.374 1.059 1.059 0 0 1-.004-.886c.064-.141.158-.269.277-.377.12-.107.26-.192.416-.25a1.394 1.394 0 0 1 .98.003c.156.06.296.146.414.254L20 18.255l2.817-2.91a1.29 1.29 0 0 1 .413-.255 1.393 1.393 0 0 1 .98-.003c.156.058.298.143.417.25.119.108.213.236.277.377a1.057 1.057 0 0 1-.004.886c-.065.14-.16.267-.28.374L21.69 20l2.93 3.025c.118.107.212.234.276.374a1.058 1.058 0 0 1 0 .883c-.064.14-.158.267-.277.374z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalloutError);
export default __webpack_public_path__ + "static/media/Icon_Callout_error.c98d6db1.svg";
export { ForwardRef as ReactComponent };